import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionInfoScreenshotComponent } from './transaction-info-screenshot.component';
import { JamPictureManagerModule } from 'ngx-jsonapi-material';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from '@app/core/core.module';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { SubmitModule } from '@app/core/components/submit/submit.module';
import { MatDividerModule } from '@angular/material/divider';
import { AddMoreScreenshotComponent } from './add-more-screenshot/add-more-screenshot.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { AlertModule } from '@app/core/components/alert-component/alert.module';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { UploadDocumentModule } from '@app/transactions/components/upload-document/upload-document.module';

const routes: Routes = [
    {
        path: '',
        component: TransactionInfoScreenshotComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    declarations: []
})
export class TransactionInfoScreenshotRoutingModule {}

@NgModule({
    declarations: [TransactionInfoScreenshotComponent, AddMoreScreenshotComponent],
    exports: [TransactionInfoScreenshotComponent],
    imports: [
        CommonModule,
        TransactionInfoScreenshotRoutingModule,
        CoreModule,
        JamPictureManagerModule,
        MatCardModule,
        SubmitModule,
        MatButtonModule,
        AlertModule,
        UploadDocumentModule,
        MatProgressSpinnerModule,
        MatDividerModule
    ]
})
export class TransactionInfoScreenshotModule {}
